<template>
  <div class='main-page-wrapper'>
    <title-section id='mainSection'></title-section>
    <about-us-section id='aboutSection'></about-us-section>
    <our-products-section id='ourProductsSection'></our-products-section>
    <location-section id='locationSection'></location-section>
    <feedback-form-section id="feedbackFormSection"></feedback-form-section>
  </div>
</template>

<script>
import TitleSection from './TitleSection.vue'
import AboutUsSection from './AboutUsSection.vue'
import OurProductsSection from './OurProductsSection.vue'
import LocationSection from './LocationSection.vue'
import FeedbackFormSection from '@/components/common/FeedbackFormSection.vue'
export default {
  name: 'MainPage',
  components: {
    TitleSection,
    AboutUsSection,
    OurProductsSection,
    LocationSection,
    FeedbackFormSection
  }
}
</script>

<style lang="scss" scoped>

</style>
